import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';

import { SwiperComponent } from "swiper/angular";
import { PaginationOptions, SwiperOptions } from 'swiper/types';
import SwiperCore, { Pagination, Virtual } from "swiper";

SwiperCore.use([Pagination, Virtual]);

const SLIDE_DURATION = 350;

export interface TutorialItem {
  icon:string;
  textIcon:string;

  image: string;
  title?: string;
  text?: string;
}

@Component({
  selector: 'app-tutorial',
  templateUrl: './tutorial.component.html',
  styleUrls: ['./tutorial.component.scss']
})
export class TutorialComponent implements OnInit {

  ngOnInit(): void {
   
  }

  @ViewChild('content', { read: SwiperComponent, static: true }) swiper?: SwiperComponent;

  @Input() items: TutorialItem[] = [];
  @Input() submitIcon?: string;
  @Input() submitText?: string;

  @Output() onSubmit = new EventEmitter<void>();

  paginationOptions: PaginationOptions = {
    clickable: true,
  };

  async handleSubmitEvent() {
    this.onSubmit.emit();
  }

  async goToSlide(slide: number) {
    this.swiper?.swiperRef.slideTo(slide, SLIDE_DURATION);
  }

}
